import { ChannelViewClinicPetParentFragment } from 'shared/types/graphql';

const getIsAllPetParentsReachableByPush = (
  clinicPetParents: ChannelViewClinicPetParentFragment[],
): { shouldDisable: boolean; enabledPetParentsLength: number } => {
  const petParentsWithPushEnabled = clinicPetParents.filter(
    ({ petParentSetting }) => !!petParentSetting?.pushNotifications,
  );
  return {
    shouldDisable: !!petParentsWithPushEnabled.length,
    enabledPetParentsLength: petParentsWithPushEnabled.length,
  };
};

export default getIsAllPetParentsReachableByPush;
